import generalSection from "../_section/section.class";
import DataForm from "./DataForm";
import {adminBonusPayslipUpload, userBonusPayslipUpload} from "./upload";

export class userBonusPayslipSection extends generalSection {
    constructor(request, mortgage, props, statementUploadFactory = null) {
        super(request, mortgage, props, statementUploadFactory ?? userBonusPayslipUpload);
        // Add missing date error

    }
}

export class adminBonusPayslipSection extends userBonusPayslipSection {
    constructor(request, mortgage, props) {
        super(request, mortgage, props, adminBonusPayslipUpload);
        this.DataForm = DataForm
        this.sortByDateProp('documentDate');
        this.activeUpload = this.uploads.find(u=> u.allValuesAnswered && u.isVerifiable)
        this.setProblems(this.problemsList.singleUploadUserProblems())
    }

    get documentDate() {
        if (this.activeUpload && this.activeUpload.values.documentDate) {
            return this.activeUpload.values.documentDate;
        }
        return null;
    }

    getSectionSummary = () => {
        return [
            {
                name: this.personalTitle,
                tags:[{
                    name: 'Dated',
                    value: this.activeUpload?.values?.documentDate?.format('D MMM YYYY') || 'Not Provided'
                }]
            }
        ]
    }
}